var $b274da0cb1751a1a$exports = {};
(()=>{
    const refs = {
        openReviewBtn: document.querySelector("[data-modal-review-open]"),
        closeReviewBtn: document.querySelector("[data-modal-review-close]"),
        modal: document.querySelector("[data-modal-review]")
    };
    refs.openReviewBtn.addEventListener("click", toggleBuy);
    refs.closeReviewBtn.addEventListener("click", toggleBuy);
    function toggleBuy() {
        refs.modal.classList.toggle("is-hidden");
    }
})();


//# sourceMappingURL=index.d8858117.js.map
